import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

export default function TawkController() {
    const location = useLocation();
    const { user } = useSelector((state) => state.auth);

    useEffect(() => {
        const isLogin = user !== null;
        let resizeTimer;

        const updateWidgetVisibility = () => {
            const isMobile = window.innerWidth < 640;

            if (window.Tawk_API && window.Tawk_API.hideWidget) {
                if (!isMobile) {
                    window.Tawk_API.showWidget();
                } else {
                    if (!isLogin) {
                        window.Tawk_API.showWidget();
                    } else {
                        window.Tawk_API.hideWidget();
                    }
                }
            }
        };

        const handleResize = () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(updateWidgetVisibility, 200);
        };

        // đảm bảo gọi khi widget load xong
        if (window.Tawk_API) {
            window.Tawk_API.onLoad = () => {
                updateWidgetVisibility();
            };
        }

        // chạy khi route change
        updateWidgetVisibility();

        // attach listener
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
            clearTimeout(resizeTimer);
        };
    }, [location, user]);

    return null;
}
